import React from 'react';
import Column from "@Containers/components/Column";
import Time from "@DateTime/components/Time";
import Row from "@Containers/components/Row";
import VehicleTypeIcon from "@Generic/vehicle/VehicleTypeIcon";
import IconMinibus from "@Icons/routeIcons/IconMinibus";
import Translation from "@Translation/components/Translation";
import RouteWithAddedPropsAndPricesType from "@Route/types/RouteWithAddedPropsAndPrices.type";
import RouteTravelDuration from "@Route/components/Connection/RouteTravelDuration";
import RouteConnection from "@Route/components/Connection/RouteConnection";
import {calculateTripDuration} from "@Route/functions/calculateTripDuration";
import {mightBeMinibus} from "@Route/features/transportType/functions/mightBeMinibus";
import RouteType from "@Route/types/Route.type";
import {Colors} from "@Styles/Colors.style";

interface RouteTravelDetailsProps {
    route: RouteWithAddedPropsAndPricesType | RouteType,
    companyLetterCode: string,
}

function RouteTravelDetails({route, companyLetterCode}: RouteTravelDetailsProps) {
    const {
        travelInfo: {
            departureStation: {
                name: departureStationName,
                departureTime,
                departureDate,
            },
            destinationStation: {
                name: destinationStationName,
                arrivalTime,
                arrivalDate,
            },
        },
        type: {
            vehicleType,
            routeTransferType,
        },
    } = route || {};

    const mightBeMinibusTranslationKey = "search_results.might_be_minibus_title";

    // This is usually calculated on routes-list level however on check-order
    // route is not ran through addRouteProperties method
    const calculatedDuration = calculateTripDuration(
        `${departureDate} ${departureTime}`,
        `${arrivalDate} ${arrivalTime}`
    );

    const longTimeString = calculatedDuration.includes("day")

    return (
            <Column className="route-travel-details">
                <Row>
                     <span className={`route-travel-details--first-column${longTimeString ? "-large" : ""}`}>
                         <Time
                             time={departureTime}
                             className="gb--emphasize-default"
                         />
                     </span>
                    <span className="gb--emphasize-default travel-stations__station-name">
                        {departureStationName}
                    </span>
                </Row>
                <Row className="travel-stations__additional-info">
                    <span className={`route-travel-details--first-column${longTimeString ? "-large" : ""} travel-time`}>
                        <RouteTravelDuration
                            travelDuration={calculatedDuration}
                            customClassName="gb--label gb--label-green"
                        />
                    </span>
                    <RouteConnection
                        route={route}
                        showVehicleIcon={false}
                        vertical
                        customClass={longTimeString ? "gb--connect-divider-large" : ""}
                    />
                    <span className="gb--label travel-stations__vehicle-type-container">
                         <span className="gb--label gb--label-default travel-stations__vehicle-type">
                             <VehicleTypeIcon
                                 transportType={routeTransferType}
                                 width="12"
                                 height="12"
                                 fill={Colors.neutralDarkestColor}
                                 className="vehicle-icon"
                             />
                             {companyLetterCode}
                         </span>
                        {mightBeMinibus(vehicleType, routeTransferType) && (
                            <span className="gb--label gb--label-default">
                                    <IconMinibus
                                        width="14"
                                        height="14"
                                    />
                                    <Translation translationKey={mightBeMinibusTranslationKey}/>
                            </span>
                        )}
                    </span>
                </Row>
                <Row className="travel-stations__destination-station">
                    <span className={`route-travel-details--first-column${longTimeString ? "-large" : ""}`}>
                         <Time
                             time={arrivalTime}
                             className="gb--emphasize-default"
                         />
                    </span>
                    <span className="gb--emphasize-default travel-stations__station-name">
                        {destinationStationName}
                    </span>
                </Row>
            </Column>
    );
}

export default RouteTravelDetails;